/**
 * Load More - Fetches and appends next page of products to collection grid
 */
class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.load-more-button');
    if (!this.button) return;

    this.button.addEventListener('click', this.onClick.bind(this));
  }

  async onClick(event) {
    event.preventDefault();
    const nextUrl = this.button.dataset.nextUrl;
    if (!nextUrl) return;

    const sectionId = this.button.dataset.sectionId;
    const grid = document.getElementById('product-grid') || document.querySelector('#ProductGridContainer [id^="Slider-"]');
    if (!grid || !sectionId) return;

    this.button.disabled = true;
    this.button.classList.add('loading');

    try {
      const fetchUrl = this.buildFetchUrl(nextUrl, sectionId);
      const response = await fetch(fetchUrl);
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const container = doc.getElementById('ProductGridContainer');

      if (!container) return;

      const newGrid = container.querySelector('#product-grid') || container.querySelector('[id^="Slider-"]');
      if (newGrid) {
        const newItems = newGrid.querySelectorAll(':scope > li');
        newItems.forEach((li) => {
          li.querySelectorAll('.scroll-trigger').forEach((el) => el.classList.add('scroll-trigger--cancel'));
          grid.appendChild(li);
        });
      }

      const newLoadMoreWrapper = container.querySelector('.load-more-wrapper');
      if (newLoadMoreWrapper) {
        const newButton = newLoadMoreWrapper.querySelector('.load-more-button');
        if (newButton && newButton.dataset.nextUrl) {
          this.button.dataset.nextUrl = newButton.dataset.nextUrl;
          this.button.disabled = false;
          this.button.classList.remove('loading');
        } else {
          this.remove();
        }
      } else {
        this.remove();
      }

      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(grid.innerHTML);
      }
    } catch (err) {
      this.button.disabled = false;
      this.button.classList.remove('loading');
    }
  }

  buildFetchUrl(nextUrl, sectionId) {
    const path = nextUrl.startsWith('/') ? nextUrl : window.location.pathname + (nextUrl.startsWith('?') ? nextUrl : '?' + nextUrl);
    const baseUrl = nextUrl.startsWith('http') ? nextUrl : window.location.origin + path;
    const url = new URL(baseUrl);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }
}

customElements.define('load-more', LoadMore);
